import Vue from 'vue'

//倒退
Vue.prototype.goBack = function () { this.$router.go(-1) }

//跳转到广告页面
Vue.prototype.goAdPage = function (url) {
	window.location.href = url
}

//主页
Vue.prototype.goShopIndex = function () {
	this.$router.push({
		path: './index',
		name: 'shop_index',
	})
}

//搜索主页
Vue.prototype.goSearchIndex = function (keyword) {
	this.$router.push({
		path: './search_index',
		name: 'search_index',
		query: {keyword: keyword,},
	})
}

//分类主页
Vue.prototype.goSortIndex = function (cate_id, cate_title) {
	let tempCateId = 0
	if (cate_id === 173) {
		tempCateId = 174
	} else {
		tempCateId = cate_id
	}
	this.$router.push({
		path: './sort_index',
		name: 'sort_index',
		query: {cate_id: tempCateId, cate_title: cate_title, },
	})
}

//文章详情
Vue.prototype.goArticleDetail = function (article_id) {
	this.$router.push({
		path: './article_detail',
		name: 'article_detail',
		query: {article_id: article_id, },
	})
}

//完善个人资料
Vue.prototype.goUserCompleteInfo = function () {
	this.$router.push({
		name: 'user_completeInfo',
		path: './user_completeInfo',
	})
}
//完善企业资料
Vue.prototype.goBusCompleteInfo = function () {
	this.$router.push({
		path: './bus_completeInfo',
		name: 'bus_completeInfo',
	})
}
//会员个人中心
Vue.prototype.goUserIndex = function () {
	this.$router.push({
		path: './user_index',
		name: 'user_index',
	})
}
//企业个人中心
Vue.prototype.goBusIndex = function () {
	this.$router.push({
		path: './bus_index',
		name: 'bus_index',
	})
}
//委员会中心
Vue.prototype.goWeiyuanIndex = function () {
	this.$router.push({
		path: './weiyuan_index',
		name: 'weiyuan_index',
	})
}

// 友情链接中心
Vue.prototype.goLinkIndex = function (link_id) {
	this.$router.push({
		path: './link_index',
		name: 'link_index',
		query: {link_id: link_id, },
	})
}


// WEBPACK FOOTER //
// ./src/global_router.js